// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const SearchResults = t.list(t.Object, 'SearchResults');

export const getDefaultState = () => new SearchResults([]);

export default SearchResults;



// WEBPACK FOOTER //
// ./src/pip/pip-search/state/search-results.js